import React from 'react'
import PropTypes from 'prop-types'

import './status-indicator.scss'

/**
 * Container to display some app status. It's similar to, but not a toast:
 *
 * - It acts as a "singleton" in that it is * not aware of other instances, and
 *   will render above any existing instances as it's positioned fixed to the
 *   viewport.
 * - It is not dismissable like a toast message.
 * - It should however look similar to a toast for consistency, currently toastr
 *   messages display a colored square to the left with a white icon, and a text
 *   message to the right.
 */
const StatusIndicator = ({ className, isVisible, children }) => {
  let classes = 'status-indicator'
  if (className) { classes += ` ${className}` }
  if (isVisible) { classes += ' status-indicator--visible' }

  return (
    <aside className={classes}>
      {children}
    </aside>
  )
}

StatusIndicator.propTypes = {
  /** Attach a CSS class name to the container element in order to apply
  * contextual style rules. */
  className: PropTypes.string,
  /** Control indicator visibility. */
  isVisible: PropTypes.bool.isRequired
}

export default StatusIndicator
